import React from 'react';
import { Alert } from 'antd';

import { ICityTax } from '../../../../interfaces';
import { formatDateStringToDateAndTime } from '../../../../utils/Conversores';

interface IProps {
    cityTax: ICityTax;
}

export default function StatusOnView({ cityTax }: IProps) {
    const {
        status,
        message,
        panel_user,
        observation,
        date_response,
    } = cityTax;

    if (status === 'Em análise') {
        return null;
    }

    const statusType = status !== 'Erro' ? 'success' : 'error';
    const statusText = status !== 'Alerta' ? message || (status === 'Erro' ? 'Recusado' : 'Aprovado') : 'Aprovado com Alerta';
    const dateResponse = date_response ? formatDateStringToDateAndTime(date_response) : '';
    const hasWarning = status === 'Alerta';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 8 }}>
            <Alert
                type={statusType}
                showIcon
                message={
                    <span style={{ fontWeight: 600 }}>
                        {statusText} {dateResponse ? `• ${dateResponse}` : ''} {panel_user?.name ? `• Analisado por: ${panel_user.name}` : ''}
                    </span>
                }
                description={
                    observation ? (
                        <div style={{ marginTop: 4 }}>
                            <strong>Observação registrada:</strong> {observation}
                        </div>
                    ) : (
                        <span style={{ fontStyle: 'italic', color: '#8c8c8c' }}>Sem observações adicionais.</span>
                    )
                }
                style={{ borderRadius: 8 }}
            />

            {hasWarning && (
                <Alert
                    type="warning"
                    showIcon
                    message="Atenção"
                    description={message}
                    style={{ borderRadius: 8 }}
                />
            )}
        </div>
    );
}